import { API } from "aws-amplify";
import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import {
  ICohort,
  ICohortUpdate,
} from "../../../../routes/registries/models/Cohort";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (cohortId: string, updateCohort: ICohortUpdate) => {
  const payload = {
    body: updateCohort,
  };

  return API.put(APIEndpoints.private, `/api/v1/cohorts/${cohortId}`, payload);
};

export const useUpdateCohort = () => {
  const queryClient = useQueryClient();

  return useMutation<
    ICohort,
    AxiosError,
    {
      cohortId: string;
      updateCohort: ICohortUpdate;
    },
    {
      previousRecord: ICohort | any;
      cohortId: string;
      updateCohort: ICohortUpdate;
    }
  >(
    ({ cohortId, updateCohort }) => {
      return makeApiRequest(cohortId, updateCohort);
    },
    {
      retry: 0,
      onSettled: () => {
        queryClient.invalidateQueries(QueryKeys.cohorts(), { exact: false });
      },
    }
  );
};
